import React from 'react';
import { MultiCheckboxFilter } from '../filters/MultiCheckboxFilter';
import { HierarchicalCheckboxFilter } from '../filters/HierarchicalCheckboxFilter';
import { UserFilterDropdown } from '../filters/UserFilterDropdown';
import { DatePeriodFilter } from '../filters/DatePeriodFilter';
import { FilterSearch } from '../filters/FilterSearch';
import { SelectFilter } from '../filters/SelectFilter';
import type { HeaderFilter } from '../../../contexts/DynamicHeaderContext';

export function FilterRenderer({ filter }: { filter: HeaderFilter }) {
  switch (filter.type) {
    case 'multi-checkbox':
      return <MultiCheckboxFilter filter={filter} />;

    case 'hierarchical-checkbox':
      return <HierarchicalCheckboxFilter filter={filter} />;

    case 'user':
      return <UserFilterDropdown filter={filter} users={filter.users} />;

    case 'search':
      return <FilterSearch filter={filter} />;

    case 'select':
      return <SelectFilter filter={filter} />;

    case 'date-range':
      return (
        <div className="flex items-center gap-1">
          <span className="text-xs font-medium text-muted-foreground whitespace-nowrap">{filter.label}:</span>
          <input
            type="date"
            value={filter.dateFrom || ''}
            onChange={(e) => filter.onDateFromChange?.(e.target.value)}
            className="px-2.5 h-7 text-xs rounded-md bg-black/5 dark:bg-white/5 border-0 text-foreground focus:outline-none w-28 transition-colors"
            title="Data da"
          />
          <span className="text-xs text-muted-foreground">—</span>
          <input
            type="date"
            value={filter.dateTo || ''}
            onChange={(e) => filter.onDateToChange?.(e.target.value)}
            className="px-2.5 h-7 text-xs rounded-md bg-black/5 dark:bg-white/5 border-0 text-foreground focus:outline-none w-28 transition-colors"
            title="Data a"
          />
          {(filter.dateFrom || filter.dateTo) && (
            <button
              onClick={() => { filter.onDateFromChange?.(''); filter.onDateToChange?.(''); }}
              className="px-2 h-7 text-xs text-muted-foreground hover:text-foreground hover:bg-black/5 rounded-md transition-colors"
            >
              ×
            </button>
          )}
        </div>
      );

    case 'date-period':
      return <DatePeriodFilter filter={filter} />;

    case 'custom':
      return filter.component ? <>{filter.component}</> : null;

    default:
      if (filter.options && filter.options.length > 0) {
        return <MultiCheckboxFilter filter={filter} />;
      }
      return null;
  }
}
